"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var owa_flex_pane_1 = require("owa-flex-pane");
var mobx_react_1 = require("mobx-react");
var HeaderFlexPane = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderFlexPane, _super);
    function HeaderFlexPane() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderFlexPane.prototype.componentDidMount = function () {
        var _a = this.props, content = _a.content, title = _a.title, onDismiss = _a.onDismiss;
        owa_flex_pane_1.lazyShowFlexPane.importAndExecute(React.createElement("div", null, content), {
            headerText: title,
            onDismiss: onDismiss,
        });
    };
    HeaderFlexPane.prototype.componentWillUnmount = function () {
        owa_flex_pane_1.lazyHideFlexPane.importAndExecute();
    };
    HeaderFlexPane.prototype.render = function () {
        return null;
    };
    HeaderFlexPane = tslib_1.__decorate([
        mobx_react_1.observer
    ], HeaderFlexPane);
    return HeaderFlexPane;
}(React.Component));
exports.default = HeaderFlexPane;
//# sourceMappingURL=HeaderFlexPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/HeaderFlexPane.js
// module id = 2955
// module chunks = 38